/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReproductiveHealthDayDto
 */
export interface ReproductiveHealthDayDto {
    /**
     * Calendar date in YYYY-MM-DD format.
     * @type {string}
     * @memberof ReproductiveHealthDayDto
     */
    date: string;
    /**
     * Day number within the month.
     * @type {number}
     * @memberof ReproductiveHealthDayDto
     */
    dayOfMonth: number;
    /**
     * Day of week where 0 is Sunday and 6 is Saturday.
     * @type {number}
     * @memberof ReproductiveHealthDayDto
     */
    dayOfWeek: number;
    /**
     * Whether this date is today in the requested timezone.
     * @type {boolean}
     * @memberof ReproductiveHealthDayDto
     */
    isToday: boolean;
    /**
     * Whether this date is the selected date.
     * @type {boolean}
     * @memberof ReproductiveHealthDayDto
     */
    isSelected: boolean;
    /**
     * Whether this date has spotting.
     * @type {boolean}
     * @memberof ReproductiveHealthDayDto
     */
    spotting: boolean;
    /**
     * Whether this date has menstrual flow.
     * @type {boolean}
     * @memberof ReproductiveHealthDayDto
     */
    menstrualFlow: boolean;
}

/**
 * Check if a given object implements the ReproductiveHealthDayDto interface.
 */
export function instanceOfReproductiveHealthDayDto(value: object): value is ReproductiveHealthDayDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('dayOfMonth' in value) || value['dayOfMonth'] === undefined) return false;
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('isToday' in value) || value['isToday'] === undefined) return false;
    if (!('isSelected' in value) || value['isSelected'] === undefined) return false;
    if (!('spotting' in value) || value['spotting'] === undefined) return false;
    if (!('menstrualFlow' in value) || value['menstrualFlow'] === undefined) return false;
    return true;
}

export function ReproductiveHealthDayDtoFromJSON(json: any): ReproductiveHealthDayDto {
    return ReproductiveHealthDayDtoFromJSONTyped(json, false);
}

export function ReproductiveHealthDayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReproductiveHealthDayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'dayOfMonth': json['dayOfMonth'],
        'dayOfWeek': json['dayOfWeek'],
        'isToday': json['isToday'],
        'isSelected': json['isSelected'],
        'spotting': json['spotting'],
        'menstrualFlow': json['menstrualFlow'],
    };
}

export function ReproductiveHealthDayDtoToJSON(json: any): ReproductiveHealthDayDto {
    return ReproductiveHealthDayDtoToJSONTyped(json, false);
}

export function ReproductiveHealthDayDtoToJSONTyped(value?: ReproductiveHealthDayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'dayOfMonth': value['dayOfMonth'],
        'dayOfWeek': value['dayOfWeek'],
        'isToday': value['isToday'],
        'isSelected': value['isSelected'],
        'spotting': value['spotting'],
        'menstrualFlow': value['menstrualFlow'],
    };
}

